"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listItemResetMixin = void 0;
/** @mixin listItemResetMixin */
/**
 * Defensive reset styles for list items.
 *
 * @example
 * import { listItemResetMixin } from '@zillow/constellation';
 *
 * const Component = styled.li`
 *     ${listItemResetMixin}
 * `;
 *
 * <Component />
 *
 * @method
 * @return {CSSObject}
 */
var listItemResetMixin = function listItemResetMixin() {
  return "\n    margin: 0;\n";
};
exports.listItemResetMixin = listItemResetMixin;